import React from "react";
import Slider from "react-slick";
import {
  CSS_BREAKPOINTS,
  CSS_BREAKPOINTS_MIN,
  PADDING_SLIDER_MOBILE,
} from "../../../config/constants";
import styles from "../../LoggedOut/StartPageView/styles";
import withStyles from "react-jss";
import styled from "styled-components";
import UserUtils from "../../../utils/user.utils";

const Container = styled.div`
  margin: 50px 0px 0 0;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    margin: 50px 0px 0 0;
  }
`;

const Title = styled.div`
  margin-bottom: 20px;
`

const Slide = styled.div`
  margin: 0 20px 0 0;
  @media ${CSS_BREAKPOINTS_MIN.sm} {
    margin: 20px 20px 0 0;
  }
`;

const Content = styled.div`
  width: ${window.innerWidth - PADDING_SLIDER_MOBILE}px;
  height: ${window.innerWidth - PADDING_SLIDER_MOBILE}px;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    width: auto;
    height: auto;
    margin-right: ${(props) => (props.index === 2 ? "0": "20px")};
  }
`;

const Text = styled.div`
  font-family: Poppins-Light, sans-serif;
  font-size: 15px;
  line-height: 26px;
  margin-top: 16px;

  width: ${window.innerWidth - PADDING_SLIDER_MOBILE}px;
  height: ${window.innerWidth - PADDING_SLIDER_MOBILE}px;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    min-height: 195px;
    height: auto;
    width: auto;
  
    font-size: 16px;
    line-height: 26px;
  }
`;

const Image = styled.div`
  width: 100%;
  height: 100%;
  background: url(${(props) => props.imageMobile}) no-repeat center / cover;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    height: 352px;
    background: url(${(props) => props.imageDesktop}) no-repeat center / cover;
  }
`;

const Achieve = (props) => {
  const { data, classes } = props;
  return (
    <Container>
      <Title>
        <h1 className={classes.avatarName}>
          <strong>What you’ll achieve</strong>
        </h1>
      </Title>

      <Slider
        arrows={false}
        autoplay={false}
        // rem is not an option here, because the slider library doesn't support rem
        centerPadding="0px"
        className="center"
        dots={false}
        variableWidth={window.innerWidth < CSS_BREAKPOINTS.sm}
        slidesToShow={window.innerWidth < CSS_BREAKPOINTS.sm ? 1 : 3}
        slidesToScroll={window.innerWidth < CSS_BREAKPOINTS.sm ? 1 : 3}
        infinite={false}
        responsive={[
          {
            breakpoint: CSS_BREAKPOINTS.sm,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ]}
      >
        {data.map(({ image, text }, idx) => (
          <Slide key={`slide-cv-${idx}`}>
            <Content index={idx}>
              <Image
                imageDesktop={UserUtils.getDataMasterCourse(
                  image,
                  "url"
                )}
                imageMobile={UserUtils.getDataMasterCourse(
                  image,
                  "url"
                )}
              />
              <Text>
                {UserUtils.getDataMasterCourse(text, "[0].text")}
              </Text>
            </Content>
          </Slide>
        ))}
      </Slider>
    </Container>
  );
};

export default withStyles(styles)(Achieve);
